module.exports = __webpack_public_path__ + "videos/3d-model_jp.ba5121a.webm";